/**
 * The ClipboardFormats class defines constants for the names of the standard data formats
 * used with the Clipboard class.
 * Flash Player 10 only supports TEXT_FORMAT, RICH_TEXT_FORMAT, and HTML_FORMAT.
 * @internal	Clipboard, ClipboardFormats and ClipboardTransferMode were all added to AIR 1.0.
 * These are also being added, with some exceptions listed in this file, to FP10.
 */
import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var ClipboardFormats = /** @class */ (function (_super) {
    __extends(ClipboardFormats, _super);
    function ClipboardFormats() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Image data (AIR only).
     */
    ClipboardFormats.BITMAP_FORMAT = 'air:bitmap';
    /**
     * An array of files (AIR only).
     */
    ClipboardFormats.FILE_LIST_FORMAT = 'air:file list';
    /**
     * File promise list (AIR only).
     */
    ClipboardFormats.FILE_PROMISE_LIST_FORMAT = 'air:file promise list';
    /**
     * HTML data.
     */
    ClipboardFormats.HTML_FORMAT = 'air:html';
    /**
     * Rich Text Format data.
     */
    ClipboardFormats.RICH_TEXT_FORMAT = 'air:rtf';
    /**
     * String data.
     */
    ClipboardFormats.TEXT_FORMAT = 'air:text';
    /**
     * A URL string (AIR only).
     */
    ClipboardFormats.URL_FORMAT = 'air:url';
    return ClipboardFormats;
}(ASObject));
export { ClipboardFormats };
